export enum Roles {
  OWNER = 'Owner',
  MANAGER = 'Manager',
  DISPENSARY = 'Dispensary',
}

export enum Permissions {
  CAN_MANAGE_REPORTS = 'CanManageReports',
}

export type AppPermission = Roles | Permissions;
